import { useThemeStore } from "../../../../stores/ThemeStore";

const GiftIllustration = () => {
  const theme = useThemeStore((s) => s.theme);
  const mainColor = theme.colors.secondary[6];
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 930 609.87353"
    >
      <path
        id="f5877e54-26d9-4110-bb17-7d90037dcb2b-288"
        data-name="Path 438"
        d="M176.062,706.84891a24.21462,24.21462,0,0,0,23.38269-4.11877c8.18977-6.87442,10.758-18.196,12.8467-28.68191l6.17973-31.01657L205.53341,651.94c-9.30465,6.40642-18.81826,13.01867-25.26011,22.29786s-9.25223,21.94707-4.07792,31.988"
        transform="translate(-135 -145.06323)"
        fill="#e6e6e6"
      />
      <path
        id="af7e5462-cb8c-4c3a-a84b-026a28a01614-289"
        data-name="Path 439"
        d="M178.0597,746.55947c-1.62839-11.86369-3.30382-23.88078-2.15884-35.87167,1.01467-10.64932,4.26373-21.04881,10.87831-29.57938A49.20592,49.20592,0,0,1,199.40383,669.668c1.26215-.79648,2.42409,1.20354,1.16733,1.997a46.77945,46.77945,0,0,0-18.50446,22.32562c-4.02858,10.24607-4.67545,21.41582-3.98154,32.3003.41944,6.58218,1.31074,13.1212,2.20588,19.65251a1.19817,1.19817,0,0,1-.808,1.42251,1.16348,1.16348,0,0,1-1.42253-.808Z"
        transform="translate(-135 -145.06323)"
        fill="#f2f2f2"
      />
      <path
        id="b74da307-8ad0-4d1b-99e4-dedad26aca71-290"
        data-name="Path 442"
        d="M189.78073,727.523a17.82513,17.82513,0,0,0,15.53141,8.01862c7.8644-.37318,14.41806-5.85973,20.31713-11.07027l17.452-15.4088-11.54987-.55281c-8.3062-.39784-16.82672-.771-24.73814,1.79338s-15.20757,8.72639-16.654,16.91541"
        transform="translate(-135 -145.06323)"
        fill="#e6e6e6"
      />
      <path
        id="eea67ff0-2845-4236-af55-5d249be779f1-291"
        data-name="Path 443"
        d="M173.45672,753.37916c7.83972-13.87142,16.93234-29.28794,33.1808-34.21552a37.02609,37.02609,0,0,1,13.95545-1.44105c1.48189.128,1.11179,2.41174-.367,2.28454a34.39833,34.39833,0,0,0-22.27164,5.89215c-6.27994,4.27453-11.16975,10.21755-15.30781,16.51907-2.53511,3.86051-4.80577,7.88445-7.07642,11.903C174.84454,755.60586,172.72271,754.67832,173.45672,753.37916Z"
        transform="translate(-135 -145.06323)"
        fill="#f2f2f2"
      />
      <rect x="241.60236" y="315.46812" width="344" height="293" fill="#fff" />
      <path
        d="M721.60236,754.53136h-346v-295h346Zm-344-2h342v-291h-342Z"
        transform="translate(-135 -145.06323)"
        fill="#3f3d56"
      />
      <rect
        x="370.60236"
        y="372.46812"
        width="86"
        height="236"
        fill={mainColor}
      />
      <rect
        x="370.60236"
        y="372.46812"
        width="86"
        height="236"
        fill={mainColor}
      />
      <polygon
        points="242.602 336.968 242.602 384.506 585.602 406.468 584.591 347.81 242.602 336.968"
        opacity="0.2"
      />
      <rect x="221.60236" y="288.46812" width="384" height="84" fill="#fff" />
      <path
        d="M741.60236,518.53136h-386v-86h386Zm-384-2h382v-82h-382Z"
        transform="translate(-135 -145.06323)"
        fill="#3f3d56"
      />
      <rect
        x="370.60236"
        y="280.46812"
        width="86"
        height="91"
        fill={mainColor}
      />
      <path
        d="M539.39446,346.18758c22.70142,33.65162,1.31244,87.77544,1.31244,87.77544s-58.19523-.43626-80.89664-34.08788-1.31244-87.77544-1.31244-87.77544S516.69305,312.536,539.39446,346.18758Z"
        transform="translate(-135 -145.06323)"
        fill={mainColor}
      />
      <path
        d="M549.81026,346.18758c-22.70141,33.65162-1.31244,87.77544-1.31244,87.77544s58.19523-.43626,80.89664-34.08788,1.31244-87.77544,1.31244-87.77544S572.51167,312.536,549.81026,346.18758Z"
        transform="translate(-135 -145.06323)"
        fill={mainColor}
      />
      <circle cx="353.60236" cy="217.46812" r="9" fill="#3f3d56" />
      <circle cx="407.60236" cy="308.46812" r="9" fill="#3f3d56" />
      <circle cx="407.60236" cy="505.46812" r="9" fill="#3f3d56" />
      <circle cx="377.60236" cy="250.46812" r="6" fill="#3f3d56" />
      <circle cx="467.60236" cy="199.46812" r="6" fill="#3f3d56" />
      <circle cx="428.60236" cy="340.46812" r="6" fill="#3f3d56" />
      <circle cx="392.60236" cy="418.46812" r="6" fill="#3f3d56" />
      <circle cx="423.60236" cy="445.46812" r="6" fill="#3f3d56" />
      <circle cx="416.60236" cy="558.46812" r="6" fill="#3f3d56" />
      <polygon
        points="786.636 597.422 775.663 597.421 770.442 555.095 786.638 555.096 786.636 597.422"
        fill="#ffb7b7"
      />
      <path
        d="M924.43436,753.122l-35.38273-.00131v-.44753a13.77268,13.77268,0,0,1,13.77195-13.77173h.00087l21.61057.00087Z"
        transform="translate(-135 -145.06323)"
        fill="#2f2e41"
      />
      <polygon
        points="813.437 597.422 824.411 597.421 829.631 555.095 813.435 555.096 813.437 597.422"
        fill="#ffb7b7"
      />
      <path
        d="M945.63827,738.90234l21.61057-.00087h.00087a13.77268,13.77268,0,0,1,13.77194,13.77173v.44753l-35.38272.00131Z"
        transform="translate(-135 -145.06323)"
        fill="#2f2e41"
      />
      <circle
        cx="902.0207"
        cy="403.18697"
        r="19.17963"
        transform="translate(4.5896 886.53434) rotate(-63.5798)"
        fill="#ffb7b7"
      />
      <path
        d="M887.89752,535.13036s-6.05673,25.23635-3.02834,37.34981,12.11347,94.88871,12.11347,94.88871l6.05674,65.61456,24.22688,2.01893-3.02834-76.71851,3.02834-66.624L944.427,656.26493v76.9473l25.69387,1.00946.55194-100.16477s2.01893-78.73743-11.104-88.832-15.1418-12.11344-15.1418-12.11344Z"
        transform="translate(-135 -145.06323)"
        fill="#2f2e41"
      />
      <path
        d="M924.47066,424.09038l22.98469,12.11344,3.02834,104.98325s-13.12294-8.07564-33.312,2.0189-33.312,3.02837-33.312,3.02837l12.11347-45.42546-5.04727-60.56726,7.21911-6.55231Z"
        transform="translate(-135 -145.06323)"
        fill="#cbcbcb"
      />
      <path
        d="M898.14743,431.77855l-4.19317,3.41583s-26.24581,13.12291-27.25528,22.208l18.1702,49.46326s5.04727,11.104,1.00947,15.1418-8.07566,14.13237-7.0662,19.17964-6.05673,26.24581,2.01893,26.24581,27.25528-48.45381,26.24581-67.63345S905.369,430.38164,898.14743,431.77855Z"
        transform="translate(-135 -145.06323)"
        fill="#2f2e41"
      />
      <path
        d="M915.79268,425.22785l9.24592-1.53851s34.32147,9.08508,39.36874,24.22691l-14.1324,35.33089s10.09459,64.60506,7.0662,64.60506H954.3128s8.07561,6.05673,3.02834,8.07564-17.16074,18.17017-20.18908,11.104-21.19854-90.8509-19.17961-109.0211S913.99986,427.13143,915.79268,425.22785Z"
        transform="translate(-135 -145.06323)"
        fill="#2f2e41"
      />
      <path
        d="M919.80526,384.40712l.89831-1.808-4.5201-2.24579s-4.9864-8.11341-14.00947-5.83336-13.08269,3.6446-13.08269,3.6446l-4.50867,2.26861,2.26288,2.25149-4.05952,1.36461,2.712,1.34746-3.15554,1.81374,1.6987,9.29786s2.82141-7.05207,8.2455-4.35714,15.34557-1.39311,15.34557-1.39311l8.61958,16.68162s1.77822-5.84774,4.94868-4.28847C921.20058,403.15124,929.30029,390.25187,919.80526,384.40712Z"
        transform="translate(-135 -145.06323)"
        fill="#2f2e41"
      />
      <path
        d="M947.88244,561.54026A9.00059,9.00059,0,0,1,954.31571,549.33l3.88561-31.74824L970.86263,528.35l-5.63095,28.49778a9.04939,9.04939,0,0,1-17.34924,4.69252Z"
        transform="translate(-135 -145.06323)"
        fill="#ffb7b7"
      />
      <path
        d="M893.72894,559.35555a9.00059,9.00059,0,0,0-7.69169-11.45929L878.8072,516.739,867.359,528.789,875.98,556.52906a9.04938,9.04938,0,0,0,17.749,2.82649Z"
        transform="translate(-135 -145.06323)"
        fill="#ffb7b7"
      />
      <path
        d="M948.37046,439.68972s13.12288-5.0473,17.16074,10.09459,9.08507,45.42545,9.08507,45.42545c.25091,16.83971-.64416,16.83971,0,33.312l-3.02834,15.1418-17.16073-2.01893.74848-38.54583-8.82415-39.18219Z"
        transform="translate(-135 -145.06323)"
        fill="#2f2e41"
      />
      <path
        d="M875.78406,451.34563l-6.222.66554s-5.89147,4.38173-5.89147,14.47627-1.00947,40.37818-1.00947,40.37818-.57254.70851,4.03781,26.24581c2.24714,12.44722,6.13047,18.321,6.13047,18.321l12.531-11.63588L883.85972,509.894l4.0378-16.15127Z"
        transform="translate(-135 -145.06323)"
        fill="#2f2e41"
      />
      <path
        d="M1064,754.53136H136a1,1,0,0,1,0-2h928a1,1,0,0,1,0,2Z"
        transform="translate(-135 -145.06323)"
        fill="#3f3d56"
      />
      <circle cx="230.64859" cy="290.20501" r="22.02776" fill="#ffb8b8" />
      <path
        d="M357.69553,565.61049q-.41615,0-.836-.03679a9.86784,9.86784,0,0,1-8.85646-11.76339,9.23861,9.23861,0,0,1,.24216-.938l-32.51113-38.451a7.66339,7.66339,0,0,1-.53316-9.13413l.05895-.07183,29.264-28.85536a8.45924,8.45924,0,0,1,11.87842,12.04733q-.055.0543-.11111.10757l-21.19485,20.14952L358.29946,545.905a9.39035,9.39035,0,0,1,1.30871.16116,9.86758,9.86758,0,0,1-1.91261,19.54433Z"
        transform="translate(-135 -145.06323)"
        fill="#ffb8b8"
      />
      <polygon
        points="266.928 596.776 277.924 596.776 283.154 554.366 266.926 554.367 266.928 596.776"
        fill="#ffb8b8"
      />
      <path
        d="M399.12375,738.24988l21.65354-.00087h.00087a13.79912,13.79912,0,0,1,13.79951,13.79869v.449l-35.45328.00134Z"
        transform="translate(-135 -145.06323)"
        fill="#2f2e41"
      />
      <polygon
        points="157.641 581.575 167.089 587.2 193.281 553.436 179.338 545.134 157.641 581.575"
        fill="#ffb8b8"
      />
      <path
        d="M292.06791,722.11807l18.60547,11.07763.00075.00046a13.79912,13.79912,0,0,1,4.797,18.91612l-.00029.00046-.22942.38533L284.77887,734.3606Z"
        transform="translate(-135 -145.06323)"
        fill="#2f2e41"
      />
      <path
        d="M415.51814,726.86015H403.20583a4.02851,4.02851,0,0,1-4.01309-3.60932l-12.4126-116.67831a1.34555,1.34555,0,0,0-2.564-.4116l-22.39254,49.58379-39.64482,64.64563a4.0551,4.0551,0,0,1-5.06585,1.58354l-15.83779-6.96816a4.03709,4.03709,0,0,1-1.83927-5.76478l36.4445-61.02314,11.17722-51.4152c-3.51538-22.2971,11.55495-55.44664,11.70778-55.77951l.07468-.162,41.5118-16.22509.20818.25486c16.37107,53.72388,26.34689,111.53991,18.98108,198.27152A4.06315,4.06315,0,0,1,415.51814,726.86015Z"
        transform="translate(-135 -145.06323)"
        fill="#2f2e41"
      />
      <path
        d="M357.16762,546.29387l-.19333-.40639c-.0924-.19443-9.32287-19.66257-16.43835-40.46987a30.69125,30.69125,0,0,1,2.12808-24.59616,31.02608,31.02608,0,0,1,19.78517-15.21419h0a31.06385,31.06385,0,0,1,36.05541,18.60367c5.64412,14.11413,3.84532,29.17924,2.1525,41.0267l-.03371.23737-.2159.10334Z"
        transform="translate(-135 -145.06323)"
        fill={mainColor}
      />
      <path
        d="M392.35661,422.82521H357.37914V407.57864c7.67716-3.05,15.18965-5.64384,19.73089,0a15.24671,15.24671,0,0,1,15.24661,15.24657Z"
        transform="translate(-135 -145.06323)"
        fill="#2f2e41"
      />
      <path
        d="M355.44265,404.88807c-20.91019,0-26.763,26.2101-26.763,40.99656,0,8.24624,3.72934,11.19562,9.58956,12.1936l2.06962-11.0378,4.84728,11.51276c1.64615.00821,3.37549-.02364,5.16832-.05691l1.6435-3.38414,3.66493,3.32342c14.6786.02187,26.54228,2.16158,26.54228-12.55093C382.20515,431.09817,377.07235,404.88807,355.44265,404.88807Z"
        transform="translate(-135 -145.06323)"
        fill="#2f2e41"
      />
      <path
        d="M448.3868,434.22219q.19948.36519.36853.7513a9.86785,9.86785,0,0,1-6.07712,13.41206,9.24155,9.24155,0,0,1-.93929.2372l-18.15655,46.96587a7.66336,7.66336,0,0,1-7.76025,4.84713l-.09127-.01726-39.353-11.84688a8.45924,8.45924,0,0,1,4.87818-16.19994q.07364.0222.14688.04569l27.84438,8.93958,21.557-38.21713a9.38748,9.38748,0,0,1-.486-1.22578,9.86762,9.86762,0,0,1,18.06859-7.69186Z"
        transform="translate(-135 -145.06323)"
        fill="#ffb8b8"
      />
      <path
        d="M798.21867,314.93171c-14.71126-19.68715-41.63633-24.43848-55.016-14.4405s-16.45312,37.16578-1.74186,56.85292c13.61709,18.2229,38.28788,23.19273,51.87646,16.36552a1.70623,1.70623,0,0,0-.008.64694l.7661,3.78749a1.72815,1.72815,0,0,0,2.75777,1.0192l6.48744-5.06824a1.7282,1.7282,0,0,0-.32149-2.92255l-3.48973-1.65968a1.71,1.71,0,0,0-.384-.12059C809.61955,358.3189,811.86537,333.19421,798.21867,314.93171Z"
        transform="translate(-135 -145.06323)"
        fill="#ccc"
      />
      <path
        d="M766.03958,307.49879a28.43178,28.43178,0,0,1,23.81222,31.08457c-.15813,1.65975,2.43513,1.6489,2.59222,0a31.08812,31.08812,0,0,0-25.71533-33.58419C765.097,304.72181,764.39579,307.21935,766.03958,307.49879Z"
        transform="translate(-135 -145.06323)"
        fill="#fff"
      />
      <path
        d="M307.19769,339.62407c12.86166-20.94237,7.33248-47.71854-6.90025-56.45949s-40.61474-1.56289-53.47639,19.37948c-11.90506,19.38475-7.41154,44.14672,3.95178,54.25292a1.7066,1.7066,0,0,0-.60414.23155l-3.23673,2.11082a1.72815,1.72815,0,0,0,.07142,2.9392l7.106,4.15682a1.72819,1.72819,0,0,0,2.59716-1.37818l.25344-3.856a1.7105,1.7105,0,0,0-.02977-.40137C271.08908,366.24354,295.26677,359.051,307.19769,339.62407Z"
        transform="translate(-135 -145.06323)"
        fill="#ccc"
      />
      <path
        d="M302.22,306.975a28.43178,28.43178,0,0,1-20.09183,33.60938c-1.60081.46606-.63292,2.872.95741,2.40893a31.08811,31.08811,0,0,0,21.71181-36.30114C304.45246,305.07335,301.87253,305.34419,302.22,306.975Z"
        transform="translate(-135 -145.06323)"
        fill="#fff"
      />
      <path
        d="M950.26462,187.99029c-1.07548-24.553-20.65376-43.63766-37.3403-42.90674s-34.52115,21.45438-33.44566,46.00735c.99548,22.72681,18.58763,40.723,33.66182,42.7303a1.70645,1.70645,0,0,0-.37079.53021l-1.499,3.56158a1.72816,1.72816,0,0,0,1.70547,2.39487l8.215-.53664a1.7282,1.7282,0,0,0,1.37957-2.59642l-1.94986-3.33628a1.71019,1.71019,0,0,0-.24947-.31584C935.2619,230.26732,951.26229,210.76651,950.26462,187.99029Z"
        transform="translate(-135 -145.06323)"
        fill={mainColor}
      />
      <path
        d="M927.85361,163.7315a28.43179,28.43179,0,0,1,2.181,39.09624c-1.06508,1.28273,1.08432,2.73367,2.14242,1.45932a31.08812,31.08812,0,0,0-2.34665-42.23351C928.63791,160.90572,926.65236,162.57516,927.85361,163.7315Z"
        transform="translate(-135 -145.06323)"
        fill="#fff"
      />
      <path
        d="M796.775,258.87236a40.78441,40.78441,0,0,1-31.9-18.89576c-.96575-1.54387-2.22647-3.24048-1.55793-5.14081a3.37989,3.37989,0,0,1,3.50209-2.339c1.97114.23991,3.24314,2.1682,3.486,4.01585.27545,2.09589-1.20316,3.74123-3.02865,4.52-4.461,1.90287-8.96171-1.0379-12.59546-3.38488-8.27978-5.34781-17.38675-10.18416-27.41958-10.79361-9.28263-.56383-19.23683,3.07583-24.4,11.12566-.9033,1.40833,1.33949,2.70971,2.23832,1.30834,5.12058-7.98343,15.4722-10.85073,24.4728-9.6168a47.57615,47.57615,0,0,1,15.31322,5.199c2.47389,1.28387,4.87324,2.70708,7.2241,4.20317a46.09642,46.09642,0,0,0,7.08547,4.06183c4.13161,1.69719,9.601,1.5646,12.487-2.34291,2.69239-3.64546.61164-9.71453-3.89154-10.7394a6.08493,6.08493,0,0,0-7.128,7.239c.44931,2.14673,2.06581,4.24753,3.31706,6.0022a43.37948,43.37948,0,0,0,32.79527,18.17034c1.66744.08248,1.66308-2.51,0-2.59222Z"
        transform="translate(-135 -145.06323)"
        fill="#ccc"
      />
    </svg>
  );
};

export default GiftIllustration;
